<template>
    <div>
      <div class="row">
            <div class="col-md-12">
                <div class="card card-stats card-raised">
                    <div class="card-body">
                      <div class="row">
                        <div class="col position-relative">
                          <div class="statistics">
                            <div class="info">
                              <div class="icon">
                                <i class="fas fa-file-import" style="cursor: auto"></i>
                              </div>
                              <h3 class="info-title">
                                <animated-number :value="statistics[0]"></animated-number>
                              </h3>
                              <h6 class="stats-title">Commandes à faire</h6>
                            </div>
                          </div>
                          <div class="separator"></div>
                        </div>
                        <div class="col position-relative">
                          <div class="statistics">
                            <div class="info">
                              <div class="icon icon-info">
                                <i class="fas fa-tools" style="cursor: auto"></i>
                              </div>
                              <h3 class="info-title">
                                <animated-number :value="statistics[1]"></animated-number>
                              </h3>
                              <h6 class="stats-title">Commandes préparées</h6>
                            </div>
                          </div>
                          <div class="separator"></div>
                        </div>
                        <div class="col position-relative">
                          <div class="statistics">
                            <div class="info">
                              <div class="icon icon-warning">
                                <i class="fas fa-pause-circle" style="cursor: auto"></i>
                              </div>
                              <h3 class="info-title">
                                <animated-number :value="statistics[2]"></animated-number>
                              </h3>
                              <h6 class="stats-title">Commandes en attente</h6>
                            </div>
                          </div>
                          <div class="separator"></div>
                        </div>
                        <div class="col position-relative">
                          <div class="statistics">
                            <div class="info">
                              <div class="icon icon-danger">
                                <i class="fas fa-exclamation-triangle" style="cursor: auto"></i>
                              </div>
                              <h3 class="info-title">
                                <animated-number :value="statistics[3]"></animated-number>
                              </h3>
                              <h6 class="stats-title">Commandes urgentes</h6>
                            </div>
                          </div>
                          <div class="separator"></div>
                        </div>
                        <!-- Nouvelle stat Sous-Traitance -->
                        <div class="col">
                          <div class="statistics">
                            <div class="info">
                              <div class="icon icon-warning">
                                <i class="fas fa-handshake" style="cursor: auto; color: #D90368"></i>
                              </div>
                              <h3 class="info-title">
                                <animated-number :value="statistics[4]"></animated-number>
                              </h3>
                              <h6 class="stats-title">Sous-Traitance</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-lg-6">
              <div class="card halloween-panel halloween-panel--comparison" style="min-height: 357px;">
                <div class="card-header">
                  <h4 class="mt-2 text-center">Évolution des commandes livrées</h4>
                </div>
                <div class="card-body d-flex flex-column justify-content-center">
                  <!-- Sélecteurs de dates pour les périodes -->
                  <div class="date-selectors mb-4 d-flex">
                    <div class="w-50 mr-4">
                      <label class="input-label">Période 1</label>
                      <fg-input type="date" addon-left-icon="now-ui-icons far fa-calendar-alt" v-model="datePeriod2">
                        <flat-picker ref="received_at" slot-scope="{focus, blur}" :config="flatpickr_config"
                                     class="datepicker" :placeholder="'Choisir une date'" v-model="datePeriod2">
                        </flat-picker>
                      </fg-input>
                    </div>
                    <div class="w-50 ">
                      <label class="input-label">Période 2</label>
                      <fg-input type="date" addon-left-icon="now-ui-icons far fa-calendar-alt" v-model="datePeriod1">
                        <flat-picker ref="received_at" slot-scope="{focus, blur}" :config="flatpickr_config"
                                     class="datepicker" :placeholder="'Choisir une date'" v-model="datePeriod1">
                        </flat-picker>
                      </fg-input>
                    </div>
                  </div>

                  <!-- Comparaison des commandes livrées -->
                  <div class="comparison d-flex justify-content-around align-items-center" style="height: 180px">

                    <div class="period text-center">
                      <h2 class="text-success text-center mb-2">
                        <animated-number :value="deliveredOrdersPeriod2"></animated-number>
                      </h2>
                      <p>Commandes livrées</p>
                    </div>
                    <div class="vs">
                      <div v-if="deliveredOrdersPeriod2 !== 0" class="d-flex justify-content-center align-items-center mb-5" style="font-size: 30px;">
                        <i v-if="percentageChange >= 0" class="fas fa-arrow-up text-success"></i>
                        <i v-if="percentageChange < 0" class="fas fa-arrow-down text-primary"></i>
                        <h4  :class="{'text-success mb-0 ml-2 mt-0': percentageChange >= 0, 'text-primary mb-0 ml-2 mt-0': percentageChange < 0}">{{ percentageChange }} %</h4>
                      </div>

                    </div>
                    <div class="period text-center">
                      <h2 class="text-primary text-center mb-2">
                        <animated-number :value="deliveredOrdersPeriod1"></animated-number>
                      </h2>
                      <p>Commandes livrées</p>
                    </div>
                  </div>
                </div>
                <img v-if="halloweenThemeEnabled" class="halloween-dashboard-witch" :src="halloweenWitchUrl" alt="" aria-hidden="true">
              </div>
            </div>
            <div class="col-lg-6">
              <div class="card halloween-panel halloween-panel--urgent" style="height: 357px">
                <div class="card-header">
                  <h3 class="fs-5 text-center mb-3"> {{ statistics[5].length }} Commandes urgentes</h3>
                </div>
                <div class="card-body" style="height: 298px; overflow: auto">
                  <div v-for="(command, index) in statistics[5]" :key="command.command_number+'-'+index">
                    <div class="card mb-2 command-item" @click="openModal(command)">
                      <div class="card-body" style="display: flex; justify-content: space-between;">
                        <p class="mb-0"> <i class="fas fa-fire mr-3" style="color: red"></i>{{
                            command.command_number }}</p>
                        <p class="mb-0">{{ command.article_type }}</p>
                        <p class="mb-0">Pour le {{ command.delivery_date_requested !== null ?
                            formatDate(command.delivery_date_requested) : '"Non renseigné"' }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="card halloween-panel halloween-panel--due" style="height: 357px">
                <div class="card-header">
                  <h3 class="fs-5 text-center mb-3"> {{ statistics[6].length }} Commandes arrivant à échéances</h3>
                </div>
                <div class="card-body" style="height: 298px; overflow: auto">
                  <div v-for="(command, index) in statistics[6]" :key="command.command_number+'-'+index">
                    <div class="card mb-2 command-item" @click="openModal(command)">
                      <div class="card-body" style="display: flex; justify-content: space-between;">
                        <p class="mb-0"> <i class="fas fa-exclamation-triangle mr-3" style="color: orange"></i>{{
                            command.command_number }}</p>
                        <p class="mb-0">{{ command.article_type }}</p>
                        <p class="mb-0">Pour le {{ command.delivery_date_requested !== null ?
                            formatDate(command.delivery_date_requested) : '"Non renseigné"' }}</p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-lg-4">
              <div class="card halloween-panel halloween-panel--late" style="height: 357px">
                <div class="card-header">
                  <h3 class="fs-5 text-center mb-3"> {{ statistics[8].length }} Commandes en retards</h3>
                </div>
                <div class="card-body" style="height: 298px; overflow: auto">
                  <div v-for="(command, index) in statistics[8]" :key="command.command_number+'-'+index">
                    <div class="card mb-2 command-item" @click="openModal(command)">
                      <div class="card-body" style="display: flex; justify-content: space-between;">
                        <p class="mb-0"> <i class="fas fa-exclamation-triangle mr-3" style="color: red"></i>{{
                            command.command_number }}</p>
                        <p class="mb-0">{{ command.article_type }}</p>
                        <p class="mb-0">Pour le {{ command.delivery_date_requested !== null ?
                            formatDate(command.delivery_date_requested) : '"Non renseigné"' }}</p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-lg-4">
            <div class="card halloween-panel halloween-panel--waiting" style="height: 357px">
              <div class="card-header">
                <h3 class="fs-5 text-center mb-3">{{ statistics[7].length }} Commandes en attentes</h3>
              </div>
              <div class="card-body" style="height: 298px; overflow: auto">
                <div v-for="(command, index) in statistics[7]" :key="command.command_number+'-'+index">
                  <div class="card mb-2 command-item" @click="openModal(command)">
                    <div class="card-body" style="display: flex; justify-content: space-between;">
                      <p class="mb-0"> <i class="fas fa-pause-circle mr-3" style="color: orange"></i>{{ command.command_number }}</p>
                      <p class="mb-0">{{ command.article_type }}</p>
                      <p class="mb-0">Pour le {{ command.delivery_date_requested !== null ?
                          formatDate(command.delivery_date_requested) : '"Non renseigné"' }}</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <template v-if="halloweenThemeEnabled">
            <img class="halloween-dashboard-skeleton" :src="halloweenSkeletonUrl" alt="" aria-hidden="true">
          </template>
          <!-- Modale pour afficher les détails de la commande cliquée -->
          <div v-if="showModal" class="modal" tabindex="-1" style="display: block; background-color: rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog" style="margin-top: 6% !important;">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Détails de la commande {{ selectedCommand.command_number }}</h5>
                  <button type="button" class="close" @click="closeModal">&times;</button>
                </div>
                <div class="modal-body">
                  <p><strong>Client :</strong> {{ selectedCommand.customer.name }}</p>
                  <p><strong>Client final:</strong> {{ selectedCommand.final_customer.name }}</p>
                  <p><strong>Type d'article :</strong> {{ selectedCommand.article_type }}</p>
                  <p><strong>Commercial :</strong> {{ selectedCommand.commercial.name }}</p>
                  <p><strong>Date de livraison demandée :</strong> {{ formatDate(selectedCommand.delivery_date_requested) || 'Non renseigné' }}</p>
                  <p><strong>Numéro de commande client :</strong> {{ selectedCommand.customer_command_number }}</p>

                  <h5 class="mt-4">Produits dans la commande :</h5>
                  <ul>
                    <!-- Boucle pour afficher les articles de la commande -->
                    <li v-for="item in selectedCommand.items" :key="item.id">
                      <div class="d-flex justify-content-between align-items-center">
                        <span><strong>{{ item.name }}</strong><br> (Réf: {{ item.ref }})</span>
                        <span><strong>x {{ item.pivot.amount }}</strong></span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" @click="closeModal">Fermer</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      <div v-if="halloweenThemeEnabled" class="halloween-dashboard-decor" aria-hidden="true">
        <img class="halloween-footer-banner" :src="halloweenFooterUrl" alt="">
      </div>
   </div>
</template>

<script>
import { AnimatedNumber} from "src/components";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import moment from "moment";
import flatPicker from "vue-flatpickr-component";
import {French} from "flatpickr/dist/l10n/fr";
import halloweenTheme from '@/mixins/halloweenTheme';
import halloweenWitchUrl from '@/assets/img/halloween/witch-cauldron.png';
import halloweenSkeletonUrl from '@/assets/img/halloween/skeleton-orders.png';
import halloweenFooterUrl from '@/assets/img/halloween/dashboard-footer-strip.png';

export default {
    mixins: [halloweenTheme],
    components: {
      flatPicker,
        AnimatedNumber,
    },
    data() {
        return {
            halloweenWitchUrl,
            halloweenSkeletonUrl,
            halloweenFooterUrl,
            showModal: false,
            selectedCommand: null,
            datePeriod1: '',
            datePeriod2: '',
            deliveredOrdersPeriod1: 0,
            deliveredOrdersPeriod2: 0,

            flatpickr_config: {
              allowInput: true,
              wrap: true, // set wrap to true only when using 'input-group'
              altFormat: 'd/m/Y',
              altInput: true,
              mode: 'range',
              dateFormat: 'Y-m-d',
              locale: French,
            },

            statistics: [0, 0, 0, 0, 0, [], [], [], []],
        };
      },
    computed: {
      percentageChange() {
        const diff = this.deliveredOrdersPeriod1 - this.deliveredOrdersPeriod2;
        const percentage = (diff / this.deliveredOrdersPeriod2) * 100;
        return Math.round(percentage);
      }
    },
    watch: {
      datePeriod1: function (newVal, oldVal){
        if(newVal){
          const [startDate, endDate] = newVal.split(' au ');
          if (startDate && endDate) {
            this.axios.get(process.env.VUE_APP_API_BASE_URL + 'dashboard/period/commands', {
              params: {
                start: startDate,
                end: endDate
              }})
                .then(response => {
                  this.deliveredOrdersPeriod1 = response.data.totalOrders
                })
          }
        }
      },
      datePeriod2: function (newVal, oldVal){
        if(newVal){
          const [startDate, endDate] = newVal.split(' au ');
          if (startDate && endDate) {
            this.axios.get(process.env.VUE_APP_API_BASE_URL + 'dashboard/period/commands', {
              params: {
                start: startDate,
                end: endDate
              }})
                .then(response => {
                  this.deliveredOrdersPeriod2 = response.data.totalOrders
                })
          }
        }
      }

    },
    mounted() {
        this.axios.get(process.env.VUE_APP_API_BASE_URL + 'dashboard/statistics')
            .then(response => {
                this.statistics = response.data
            })
            .catch(error => {
                // handle the error
            });

        const currentDate = new Date();
        const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        const lastYearSamePeriod = new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate());

        this.datePeriod1 = [startOfMonth, currentDate];
        this.datePeriod2 = [new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), 1), lastYearSamePeriod];


    },
    methods: {
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY')
        },
      openModal(command) {
        this.selectedCommand = command;
        this.showModal = true;
      },
      // Ferme la modale
      closeModal() {
        this.showModal = false;
        this.selectedCommand = null;
      },
    }
};
</script>

<style>
  /* Animation légère au survol */
.command-item {
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.command-item:hover {
  cursor: pointer;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5); /* Ombre légère */
}

/* Styles pour la modale */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-dialog {
  max-width: 500px;
  width: 100%;
}

.modal-content {
  background-color: #fff;
  border-radius: 8px;
  padding: 1rem;
}

.modal-header, .modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close {
  border: none;
  background: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.fs-5 {
    font-size: 1.25rem;
}

.default-datagrid .e-pager .e-currentitem,
.e-pager .e-currentitem:hover {
    background: #f96332;
    color: #fff;
    opacity: 1;
}

.separator {
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background-color: #e0e0e0; /* Couleur du séparateur */
}

.col:not(:last-child) .separator {
  display: block;
}

.col:last-child .separator {
  display: none; /* Pas de séparateur après la dernière colonne */
}
</style>
